/**
 * 線の絵（24×24、線の太さ2）。飾りなので読み上げない。意味はボタンの文字か aria-label で伝える
 */
const PATHS: Record<string, string> = {
  play: "M8 5.5v13l10.5-6.5z",
  pause: "M8 5h3v14H8zM13 5h3v14h-3z",
  skip: "M6 5.5v13l9-6.5zM17 5v14",
  stop: "M7 7h10v10H7z",
  plus: "M12 5v14M5 12h14",
  queue: "M4 6h12M4 12h12M4 18h8M18 15v6M15 18h6",
  heart: "M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z",
  bookmark: "M7 4h10v16l-5-3.5L7 20z",
  sparkle: "M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5 18 18M18 6l-2.5 2.5M8.5 15.5 6 18",
  search: "M10.5 17a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13zM15.5 15.5 20 20",
  compass: "M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18zM15.5 8.5l-2 5-5 2 2-5z",
  wave: "M3 12h2M7 8v8M11 5v14M15 9v6M19 11v2",
  library: "M5 4v16M9 4v16M13 5l4 15",
  history: "M4 12a8 8 0 1 0 2.3-5.6M4 4v4h4M12 8v4l3 2",
  more: "M6 12h.01M12 12h.01M18 12h.01",
  close: "M6 6l12 12M18 6 6 18",
  up: "M12 19V5M6 11l6-6 6 6",
  down: "M12 5v14M6 13l6 6 6-6",
  trash: "M5 7h14M10 11v6M14 11v6M7 7l1 13h8l1-13M9 7V4h6v3",
  external: "M14 4h6v6M20 4l-9 9M18 14v5H5V6h5",
  speaker: "M4 9v6h4l5 4V5L8 9zM16.5 8.5a5 5 0 0 1 0 7M19 6a8.5 8.5 0 0 1 0 12",
  warn: "M12 4 2.5 20h19zM12 10v4M12 17h.01",
  check: "M5 12.5l4.5 4.5L19 7",
  clock: "M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18zM12 7v5l3 2",
  edit: "M4 20h4L19 9l-4-4L4 16zM14 6l4 4",
  repeat: "M4 11V9a3 3 0 0 1 3-3h11M15 3l3 3-3 3M20 13v2a3 3 0 0 1-3 3H6M9 21l-3-3 3-3",
  seek: "M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18zM12 12l4-4M12 7v1",
  flag: "M5 21V4M5 4h11l-2 4 2 4H5",
  eyeOff:
    "M3 3l18 18M10.6 6.1A9.8 9.8 0 0 1 12 6c5 0 8.5 4 9.5 6a12 12 0 0 1-2.6 3.4M6.3 7.6A12.6 12.6 0 0 0 2.5 12c1 2 4.5 6 9.5 6a9.6 9.6 0 0 0 4-.9M9.9 9.9a3 3 0 0 0 4.2 4.2",
  refresh: "M20 11a8 8 0 0 0-14.5-4.5L4 8M4 4v4h4M4 13a8 8 0 0 0 14.5 4.5L20 16M20 20v-4h-4",
  user: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4 21a8 8 0 0 1 16 0",
  link: "M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1",
  wifiOff:
    "M3 3l18 18M8.5 16.5a5 5 0 0 1 7 0M5 12.5a10 10 0 0 1 4-2.4M14.5 10a10 10 0 0 1 4.5 2.5M2 8.8a15 15 0 0 1 4.3-2.6M11 5.1A15 15 0 0 1 22 8.8M12 20h.01",
};

export type IconName = keyof typeof PATHS;

const FILLED = new Set(["play", "pause", "stop"]);

export function Icon({ name, className = "icon" }: { name: IconName; className?: string }) {
  const filled = FILLED.has(name);
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      width="24"
      height="24"
      aria-hidden="true"
      focusable="false"
      fill={filled ? "currentColor" : "none"}
      stroke={filled ? "none" : "currentColor"}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
